import { render, staticRenderFns } from "./yarn.vue?vue&type=template&id=563fd0f6&scoped=true"
import script from "./yarn.vue?vue&type=script&lang=js"
export * from "./yarn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fd0f6",
  null
  
)

export default component.exports